import { Component, HostListener } from '@angular/core';
import { TenantDeparmentDto } from 'app/api/models/tenant/tenantDeparmentDto';
import { TenantFolderDto } from 'app/api/models/tenant/tenantFolderDto';
import { TenantsService } from 'app/state/tenants.service';
import { Table } from 'primeng/table';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'app-tenant-departments',
  templateUrl: './tenant-departments.component.html',
  styleUrl: './tenant-departments.component.scss',
})
export class TenantDepartmentsComponent {
  constructor(private tenantService: TenantsService) {}
  deleteConfirmation: TenantDeparmentDto | null = null;

  departments: TenantDeparmentDto[] = [];
  newDepartmentText: string = '';
  innerWidth = 0;
  @HostListener('window:resize', ['$event'])
  ngOnInit(): void {
    this.refreshData();
    this.innerWidth = window.innerWidth;
  }
  onResize() {
    this.innerWidth = window.innerWidth;
  }

  addDepartment() {
    if (this.newDepartmentText.trim()) {
      let newDepartment = new TenantDeparmentDto();
      newDepartment.name = this.newDepartmentText;
      this.tenantService
        .addTenantDepartment(newDepartment)
        .pipe(untilDestroyed(this))
        .subscribe((x) => {
          this.refreshData();
          this.newDepartmentText = '';
        });
    }
  }

  refreshData() {
    this.tenantService.getAllTenantsDepartments().subscribe((x) => {
      this.departments = x;
    });
  }

  handleDeleteClick(department: TenantDeparmentDto) {
    this.tenantService.deleteTenantDepartment(department.id!).subscribe(() => {
      this.refreshData();
    });
  }

  onGlobalFilter(table: Table, event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    table.filterGlobal(inputElement.value, 'contains');
  }
}
